import { join } from 'light-component';
import { Input } from 'antd';
import { Box } from '../../../box';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { TextAreaProps } from './types';

export function TextAreaViewMode(props: TextAreaProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Input.TextArea
          value={props.value}
          readOnly={true}
        />
      </Box>
    </Box>
  );
}
